import { render, staticRenderFns } from "./PCIndex.vue?vue&type=template&id=76ce2a58&scoped=true&"
import script from "./PCIndex.vue?vue&type=script&lang=js&"
export * from "./PCIndex.vue?vue&type=script&lang=js&"
import style0 from "./PCIndex.vue?vue&type=style&index=0&id=76ce2a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce2a58",
  null
  
)

export default component.exports